export function shareOf(part: number, total: number): number | null {
  return total > 0 ? part / total : null;
}
